<template>
  <div class="login-container">
    <img class="slant-logo" src="../assets/Slant3d.png" />
    <h2 class="api-text">API</h2>
    <div class="button-wrapper">
      <button class="btn btn-docs" title="Visit Documentation" @click="goToDocs">Go to Docs</button>
      <button class="btn btn-docs" @click="signInWithGoogle">Sign In with Google</button>
    </div>
    <div class="svg-background">
      <svg id="visual" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1">
        <rect x="0" y="0" fill="#e2e2e2"></rect>
        <defs>
          <linearGradient id="grad1_0" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#3a6afd" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#3a6afd" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad1_1" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#3a6afd" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#7b86f7" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad1_2" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#a3a4f1" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#7b86f7" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad1_3" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#a3a4f1" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#c5c2ea" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad1_4" x1="43.8%" y1="100%" x2="100%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#e2e2e2" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#c5c2ea" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_0" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#3a6afd" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#3a6afd" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_1" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#7b86f7" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#3a6afd" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_2" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#7b86f7" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#a3a4f1" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_3" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#c5c2ea" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#a3a4f1" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="grad2_4" x1="0%" y1="100%" x2="56.3%" y2="0%">
            <stop offset="14.444444444444446%" stop-color="#c5c2ea" stop-opacity="1"></stop>
            <stop offset="85.55555555555554%" stop-color="#e2e2e2" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <g transform="translate(1920, 1080)">
          <path
            d="M-702 0C-679.3 -42.5 -656.6 -84.9 -649.3 -129.1C-642 -173.4 -650.2 -219.4 -643.9 -266.7C-637.7 -314 -617.1 -362.6 -569.6 -380.6C-522 -398.5 -447.4 -385.9 -418.6 -418.6C-389.8 -451.3 -406.8 -529.2 -390 -583.7C-373.3 -638.2 -322.8 -669.2 -268.3 -647.6C-213.8 -626.1 -155.2 -551.9 -109.8 -552.2C-64.5 -552.5 -32.2 -627.2 0 -702L0 0Z"
            fill="#d4d2e6"></path>
          <path
            d="M-561.6 0C-543.4 -34 -525.2 -67.9 -519.4 -103.3C-513.6 -138.7 -520.1 -175.5 -515.2 -213.4C-510.2 -251.2 -493.7 -290.1 -455.6 -304.5C-417.6 -318.8 -357.9 -308.8 -334.9 -334.9C-311.8 -361 -325.4 -423.4 -312 -467C-298.6 -510.5 -258.2 -535.4 -214.6 -518.1C-171 -500.9 -124.2 -441.5 -87.9 -441.7C-51.6 -442 -25.8 -501.8 0 -561.6L0 0Z"
            fill="#b5b3ee"></path>
          <path
            d="M-421.2 0C-407.6 -25.5 -393.9 -50.9 -389.6 -77.5C-385.2 -104 -390.1 -131.7 -386.4 -160C-382.6 -188.4 -370.3 -217.6 -341.7 -228.3C-313.2 -239.1 -268.4 -231.6 -251.2 -251.2C-233.9 -270.8 -244.1 -317.5 -234 -350.2C-224 -382.9 -193.7 -401.5 -161 -388.6C-128.3 -375.6 -93.1 -331.1 -65.9 -331.3C-38.7 -331.5 -19.3 -376.3 0 -421.2L0 0Z"
            fill="#9095f4"></path>
          <path
            d="M-280.8 0C-271.7 -17 -262.6 -34 -259.7 -51.7C-256.8 -69.4 -260.1 -87.8 -257.6 -106.7C-255.1 -125.6 -246.9 -145 -227.8 -152.2C-208.8 -159.4 -179 -154.4 -167.4 -167.4C-155.9 -180.5 -162.7 -211.7 -156 -233.5C-149.3 -255.3 -129.1 -267.7 -107.3 -259.1C-85.5 -250.4 -62.1 -220.8 -43.9 -220.9C-25.8 -221 -12.9 -250.9 0 -280.8L0 0Z"
            fill="#6078fa"></path>
          <path
            d="M-140.4 0C-135.9 -8.5 -131.3 -17 -129.9 -25.8C-128.4 -34.7 -130 -43.9 -128.8 -53.3C-127.5 -62.8 -123.4 -72.5 -113.9 -76.1C-104.4 -79.7 -89.5 -77.2 -83.7 -83.7C-78 -90.3 -81.4 -105.8 -78 -116.7C-74.7 -127.6 -64.6 -133.8 -53.7 -129.5C-42.8 -125.2 -31 -110.4 -22 -110.4C-12.9 -110.5 -6.4 -125.4 0 -140.4L0 0Z"
            fill="#3a6afd"></path>
        </g>
        <g transform="translate(0, 0)">
          <path
            d="M702 0C636.1 36.8 570.2 73.5 546.3 108.7C522.4 143.8 540.4 177.3 566.3 234.6C592.2 291.9 626 372.9 583.7 390C541.4 407.1 423 360.3 376.2 376.2C329.3 392.1 354 470.6 335.6 502.2C317.1 533.8 255.5 518.4 210.5 508.1C165.4 497.8 136.9 492.5 104.6 525.7C72.2 558.9 36.1 630.4 0 702L0 0Z"
            fill="#d4d2e6"></path>
          <path
            d="M561.6 0C508.9 29.4 456.2 58.8 437 86.9C417.9 115 432.3 141.8 453.1 187.7C473.8 233.5 500.8 298.3 467 312C433.1 325.7 338.4 288.2 300.9 300.9C263.5 313.6 283.2 376.5 268.5 401.8C253.7 427 204.4 414.8 168.4 406.5C132.3 398.3 109.5 394 83.7 420.6C57.8 447.1 28.9 504.3 0 561.6L0 0Z"
            fill="#b5b3ee"></path>
          <path
            d="M421.2 0C381.7 22.1 342.1 44.1 327.8 65.2C313.4 86.3 324.3 106.4 339.8 140.8C355.3 175.1 375.6 223.7 350.2 234C324.8 244.3 253.8 216.2 225.7 225.7C197.6 235.2 212.4 282.4 201.3 301.3C190.3 320.3 153.3 311.1 126.3 304.9C99.3 298.7 82.1 295.5 62.7 315.4C43.3 335.3 21.7 378.3 0 421.2L0 0Z"
            fill="#9095f4"></path>
          <path
            d="M280.8 0C254.4 14.7 228.1 29.4 218.5 43.5C209 57.5 216.2 70.9 226.5 93.8C236.9 116.7 250.4 149.2 233.5 156C216.6 162.8 169.2 144.1 150.5 150.5C131.7 156.8 141.6 188.2 134.2 200.9C126.8 213.5 102.2 207.4 84.2 203.3C66.2 199.1 54.8 197 41.8 210.3C28.9 223.5 14.4 252.2 0 280.8L0 0Z"
            fill="#6078fa"></path>
          <path
            d="M140.4 0C127.2 7.4 114 14.7 109.3 21.7C104.5 28.8 108.1 35.5 113.3 46.9C118.4 58.4 125.2 74.6 116.7 78C108.3 81.4 84.6 72.1 75.2 75.2C65.9 78.4 70.8 94.1 67.1 100.4C63.4 106.8 51.1 103.7 42.1 101.6C33.1 99.6 27.4 98.5 20.9 105.1C14.4 111.8 7.2 126.1 0 140.4L0 0Z"
            fill="#3a6afd"></path>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged } from "firebase/auth";
import { gsap } from 'gsap';

export default {
  name: "LoginButton",
  data() {
    return {};
  },
  methods: {
    goToDocs() {
      this.$router.push('/Docs');
    },
    checkIfLoggedIn() {
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user) {
          // User is logged in, redirect to home page
          this.$router.push('/');
        }
      });
    },
    async signInWithGoogle() {
      const provider = new GoogleAuthProvider();
      const auth = getAuth();

      try {
        await signInWithPopup(auth, provider);
        this.$router.push('/'); // Redirect to home after successful login
      } catch (error) {
        console.error("Google Sign In Error:", error);
      }
    },
    animatePaths() {
      const paths = this.$el.querySelectorAll('#visual path');

      paths.forEach((path, index) => {
        gsap.to(path, {
          duration: 4,
          ease: 'power1.inOut',
          repeat: -1,
          yoyo: true,
          attr: {
            transform: `translate(${30 * Math.sin(index)}, ${30 * Math.cos(index)})`
          }
        });
      });
    },
  },
  mounted() {
    this.animatePaths();
    this.checkIfLoggedIn()
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background-image: url("../assets/SVG-Backdrop.svg"); */
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100dvh;
}

.svg-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: #e2e2e2;
}

#visual {
  display: block;
  width: 100%;
  height: 100%;
}

.button-wrapper {
  color: white;
}

.sign-in-button {
  background-color: #7b86f7;
  color: #f1f1f1;
  padding: 2rem;
  border-radius: 8px;
  font-weight: 700;
}

.sign-in-button:hover {
  background-color: #656dc9;
}

.slant-logo {
  height: 150px;
  margin-bottom: 2rem;
}

.api-text {
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 2rem;
}

.btn {
  margin: 10px;
  padding: 12px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.btn-docs {
  background-color: #3a6afd;
  color: white;
}

.btn-signup {
  background-color: #e74c3c;
  color: white;
}

.btn-discord {
  font-size: 36px;
  padding: 0rem;
}

.btn:hover {
  opacity: 0.9;
}
</style>
